import Vue from "vue";

Vue.component("AttendanceMoveForms", () => import("./MoveForms.vue"));
Vue.component("AttendanceShow", () => import("./Show.vue"));
Vue.component("AttendanceTimeline", () => import("./Timeline.vue"));
Vue.component("TransferAttendance", () => import("./Transfer.vue"));
